"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircle = _interopRequireDefault(require("./IconArrowDownCircle"));
var IconArrowUpCircle = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircle.default).withConfig({
  displayName: "IconArrowUpCircle",
  componentId: "c11n-8-107-0__sc-1h3m26u-0"
})(["transform:rotate(180deg);"]);
var _default = IconArrowUpCircle;
exports.default = _default;